const disableMultipleClickMixin = {
    data() {
        return {
            isProcessed: false,
        };
    },
    methods: {
        disableClickable() {
            this.isProcessed = true;
        },
    },
};

function initCreateOneClickInquiry(app) {
    app.component('create-one-click-inquiry', {
        template: '#create-one-click-inquiry',
        mixins: [disableMultipleClickMixin],
        props: {
            infoText: {
                type: String,
                required: true,
            },
            buttonText: {
                type: String,
                required: true,
            },
            createInquiryUrl: {
                type: String,
                required: true,
            },
            actionButtonId: {
                type: String,
                required: false,
            },
        },
        methods: {
            createInquiryOneClick() {
                this.disableClickable();
                const form = this.$refs.createOneClickInquiryForm;
                if (form) {
                    form.submit();
                }
            },
        },
    });
}

export default initCreateOneClickInquiry;
